let languages = ["es", "en"];

let copies = {};

function setCopies(serverCopies) {
  copies = serverCopies;
}

function getCopy(key) {
  return copies[key] || key;
}

export default {
  languages,
  copies,
  setCopies,
  getCopy
};
